import React from 'react';
import { TExternalComponentProps } from '../@shared/sharedExternalComponent/types/externalComponent.types';
import SharedExternalComponent from '../@shared/sharedExternalComponent';

const BuildAndPriceExternalLink = (props: TExternalComponentProps) => {
  return <SharedExternalComponent {...props} />
};

export default BuildAndPriceExternalLink;
